import request from '@/utils/request'
import md5 from 'js-md5'
// 用户登录
export function postLogin(username, password, imgValidateCode) {
  var password = md5(password);
  var imgValidateCode = md5(imgValidateCode.toLowerCase());
  return request({
    url: '/login?channel=1',
    method: 'post',
    // header: imgValidateCode,
    headers: {'imgValidateCode': imgValidateCode},
    data: {
      username,
      password,
      imgValidateCode
    }
  })
}
// 查询用户信息
export function getInfo(token) {
  return request({
    url: '/account/getAccountInfo',
    method: 'get',
    headers: {'token': token},
    params: {
      channel:1
    }
  })
}
// 登出
export function logout() {
  return request({
    url: '/user/logout?channel=1',
    method: 'post'
  })
}
// 验证码
export function getImgCode(width,height) {
  var width = width || "";
  var height = height || "";
  return process.env.BASE_API +'getImgValidate?channel=1&interference_line_num=0&width='+ width +"&height="+ height +"&random="+ Math.random()
}



// WEBPACK FOOTER //
// ./src/api/login.js